import React from "react";

type Props = {
   when: boolean;
   children: React.ReactNode;
};
export default function Show({ when, children }: Props) {
   if (!when) return null;
   return <>{children}</>;
}
